import faker from './faker';
import helper from './helper';

export default (app) => {
    app.use(faker);
    app.use(helper);
    // app.use(lodash)
};
